<template>
  <div class="hello">
    <h1 class="listtile">{{ msg }}</h1>
    <div class="container">
      <div class="columns is-multiline is-mobile has-text-centered">
        <div v-for="prod in post" class="column is-3-tablet is-6-mobile">
          <h3>{{ prod.name }}</h3>
          <img v-bind:src="prod.image" style="max-width:200px">
          <h4>{{ prod.artno }}</h4>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'doslist',
    props: {
      msg: String
    },
    data: function () {
      return {
        post: ""

      };
    },

    created() {
      // this.rutt = this.$route.query.page;(
      console.log("this.$route");
      var currentUrl = window.location.pathname;
      console.log(currentUrl);
      if (currentUrl == '/lista.html' || currentUrl == '/lista') {
        this.$http.get("/list.json")
          .then(res => {
            this.post = res.body;
          });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h3 {
    margin: 40px 0 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>